import Vue from 'vue';
import VueToastr from 'vue-toastr';

Vue.use(VueToastr);

// Patch prototype.e để suppress toast khi message null/empty (permission error đã handled)
const proto = Vue.prototype.$toastr;
if (proto && proto.e) {
  const _e = proto.e;
  proto.e = function (opts, ...args) {
    const msg =
      opts && typeof opts === 'object' ? opts.msg || opts.message : opts;
    if (!msg) return;
    return _e.call(this, opts, ...args);
  };
}
